// cahce key
export const LOGIN_USER = "loginUser";
export const LOGIN_PASSWORD = "loginPassword";
export const LOGIN_REM_PASSWORD = "loginRemPassword";
